import { TextCollectionAttachment } from '@scale/shared/types/params/textcollection';

export interface ChatMockProps {
  attachment: TextCollectionAttachment;
}

export const validateChats = (chats: any) => {
  if (
    Array.isArray(chats) &&
    chats.every(
      chat =>
        Array.isArray(chat) &&
        chat.every(turn => (turn.role === 'user' || turn.role === 'model') && turn.text),
    )
  )
    return true;
  return false;
};
